import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { UiModule } from '@mom/ui';

import { AddListAttributeDirective } from './directives/add-list-attribute.directive';
import { FaIconColorDirective } from './directives/fa-icon-color.directive';
import { DaysUntilTodayPipe } from './pipes/days-until-today.pipe';
import { DeadlineTimePipe } from './pipes/deadline-time.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ToFormArrayPipe } from './pipes/to-form-array.pipe';
import { ToFormControlPipe } from './pipes/to-form-control.pipe';
import { ToFormGroupPipe } from './pipes/to-form-group.pipe';
import { TransformToUiOptionPipe } from './pipes/transform-to-ui-options.pipe';

@NgModule({
  declarations: [
    AddListAttributeDirective,
    FaIconColorDirective,
    DaysUntilTodayPipe,
    DeadlineTimePipe,
    SafeHtmlPipe,
    ToFormArrayPipe,
    ToFormControlPipe,
    ToFormGroupPipe,
    TransformToUiOptionPipe
  ],
  imports: [CommonModule, FontAwesomeModule, IonicModule, IonicStorageModule, UiModule],
  exports: [
    AddListAttributeDirective,
    FaIconColorDirective,
    DaysUntilTodayPipe,
    DeadlineTimePipe,
    SafeHtmlPipe,
    ToFormArrayPipe,
    ToFormControlPipe,
    ToFormGroupPipe,
    TransformToUiOptionPipe
  ]
})
export class SharedModule {}
